import React, { useEffect, useState } from 'react';
import { FileDrop } from '../helpers/FileDrop';
import { getText } from '../../i18n';

const PropertiesVideo = ({ item, setItem, setUploadFile }) => {
    const [areInputsDisabled, setAreInputsDisabled] = useState(false);
    const [captionCharacterLimitLabel, setCaptionCharacterLimitLabel] =
        useState('Character Limit 0/200');
    const [captionCharacterLimitStatus, setCaptionCharacterLimitStatus] =
        useState('rgba(47, 43, 67, 0.6)');
    const [format, setFormat] = useState('url');
    const [videoUrl, setVideoUrl] = useState('');
    const [caption, setCaption] = useState('');
    const [file, setFile] = useState();
    const [isExternal, setIsExternal] = useState(true);

    useEffect(() => {
        setItem(prevState => ({
            ...prevState,
            videoPart: {
                url: videoUrl,
                caption: caption,
                isExternal: isExternal, // Todo: save actual value based on url / upload radio choice
            },
        }));
    }, [videoUrl, caption, isExternal]);

    useEffect(() => {
        setUploadFile(file);
    }, [file]);

    useEffect(() => {
        if (item !== undefined) {
            if (item.hasOwnProperty('templateStatus')) {
                if (item.templateStatus === -1) {
                    //Template is locked, activate view-only mode
                    setAreInputsDisabled(true);
                }
            }
        }
    }, []);

    const handleCaptionChange = event => {
        handleCaptionCharacterLimit(event);
        setCaption(event.target.value);
    };

    const handleCaptionCharacterLimit = event => {
        var str = event.target.value.toString();
        if (str.length > 200) {
            setCaptionCharacterLimitStatus('rgba(239, 78, 69, 1)');
        } else {
            setCaptionCharacterLimitStatus('rgba(47, 43, 67, 0.6)');
        }
        setCaptionCharacterLimitLabel('Character Limit ' + str.length + '/200');
    };

    const handleURLChange = event => {
        setVideoUrl(event.target.value);
    };

    const handleFormatChange = event => {
        setFormat(event.target.value);
        // Todo: save actual value based on url / upload radio choice
    };

    //Todo: Delete this once we have definitive data field for the video url
    useEffect(() => {
        if (item.videoPart && item.videoPart.url) {
            setVideoUrl(item.videoPart.url);
        } else {
            // Demo default video url
            //setVideoUrl("https://www.youtube.com/watch?v=TIASy1IxUKs");
            setVideoUrl('');
        }

        if (item.videoPart && item.videoPart.caption) {
            setCaption(item.videoPart.caption);
        } else {
            // Demo default video url
            //setCaption("Effective employee communication meets employees where they are. As your work environment changes, you can ensure your plan and your people continue to thrive with iNGAGED.");
            setCaption('');
        }

        // Todo: Check if item.videoPart.isExternal is true or false, and switch to URL or Upload when this last one is implemented
    }, [item.data]);

    const handleFileChange = fileValue => {
        setFile(fileValue);
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    minWidth: '100%',
                    margin: 'auto',
                    paddingTop: '26px',
                }}
            >
                {/*<div className="file-form-label">Format<span style={{ color: "#EF4E45", marginLeft: "4px", fontWeight: "500" }}>*</span></div>
                <div className="form-check">
                    <input className="form-check-input" type="radio" name="flexRadioURL" id="flexRadioURL" value="url" checked={format === "url"} onChange={handleFormatChange} disabled={areInputsDisabled}/>
                    <label className="form-check-label" htmlFor="url">URL</label>
                </div>
                <input onChange={handleURLChange} placeholder="Enter Video URL" defaultValue={videoUrl} style={{ display: format === "url" ? 'block' : 'none', height: "48px", borderRadius: "12px", border: "solid 1px rgba(47, 43, 67, 0.2)", paddingLeft: "16px", paddingRight: "16px", marginTop: "10px" }} className="form-control" type="text" aria-label="enter video url" disabled={areInputsDisabled}></input>*/}

                <div className="file-form-label">
                    {getText('msg_041a5dec481d')}
                    <span
                        style={{
                            color: '#EF4E45',
                            marginLeft: '4px',
                            fontWeight: '500',
                        }}
                    >
                        *
                    </span>
                </div>
                <div
                    className="form-check"
                    style={{ float: 'left', marginRight: '200px' }}
                >
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioURL"
                        id="flexRadioURL"
                        value="url"
                        checked={isExternal === true}
                        onChange={() => setIsExternal(true)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="url">
                        {getText('msg_0e2d9b0777a4')}
                    </label>
                </div>
                <div className="form-check" style={{ float: 'left' }}>
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioUpload"
                        id="flexRadioUpload"
                        value="upload"
                        checked={isExternal === false}
                        onChange={() => setIsExternal(false)}
                        disabled={areInputsDisabled}
                    />
                    <label className="form-check-label" htmlFor="upload">
                        {getText('msg_8bdf057f91e7')}
                    </label>
                </div>
                <div style={{ marginTop: '46px' }}>
                    <input
                        onChange={handleURLChange}
                        placeholder={getText('msg_85eccc61fc42')}
                        defaultValue={videoUrl}
                        style={{
                            display: isExternal === true ? 'block' : 'none',
                            height: '48px',
                            borderRadius: '12px',
                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                            paddingLeft: '16px',
                            paddingRight: '16px',
                        }}
                        className="form-control"
                        type="text"
                        aria-label={getText('msg_f0aa41e6ba0a')}
                        disabled={areInputsDisabled}
                    ></input>
                    <span
                        style={{
                            display: isExternal === false ? 'block' : 'none',
                        }}
                    >
                        <FileDrop file={file} onChange={handleFileChange} />
                    </span>
                </div>
            </div>
            <div
                style={{
                    width: '100%',
                    minWidth: '100%',
                    margin: 'auto',
                    paddingTop: '26px',
                }}
            >
                <div className="file-form-label">{getText('msg_3428d97e6666')}</div>
                <textarea
                    onChange={handleCaptionChange}
                    defaultValue={caption}
                    className="form-control"
                    placeholder={getText('msg_31cf7b6c5fdf')}
                    style={{
                        height: '100px',
                        borderRadius: '12px',
                        border: 'solid 1px rgba(47, 43, 67, 0.2)',
                        resize: 'none',
                        padding: '16px',
                    }}
                    disabled={areInputsDisabled}
                ></textarea>
                <div
                    style={{
                        fontSize: '14px',
                        fontWeight: '400',
                        textAlign: 'left',
                        color: captionCharacterLimitStatus,
                        marginLeft: '8px',
                        marginTop: '8px',
                    }}
                >
                    {captionCharacterLimitLabel}
                </div>
            </div>
        </>
    );
};

export default PropertiesVideo;
